<div class="gap-medpace border-color-border border border-solid p-d-medpace rounded-medpace flex flex-col">
    <div class="flex flex-1 justify-between">
        <h5>Expense {{ index() + 1 }}</h5>
    </div>
    <div>
        <h5>Expense Type</h5>
        <span>{{ expenseType$ | async }}</span>
    </div>
    @if (isTypeMileageExpense()) {
        <medpace-mileage-expense-view [expense]="expense()" />
    } @else {
        <medpace-other-expense-view [expense]="expense()" />
    }

    @let elevatedAccess = elevatedAccess$ | async;
    @let isInProcessOrHigher = isInProcessOrHigher$ | async;
    @if (isInProcessOrHigher === true && elevatedAccess === true) {
        <div class="break-words">
            <h5>Notes</h5>
            <span>{{ expense().notes ?? 'Unspecified' }}</span>
        </div>
    }
</div>
